import * as React from 'react';
import GAF from './GAF';
import MADRS from './MADRS';

const InterviewSurveysForm = ({ document }: IOwnProps): React.JSX.Element | null =>
  document?._type === 'madrs' ? <MADRS /> : document?._type === 'gaf' ? <GAF /> : null;

interface IOwnProps {
  document: IDocumentWithTypeV2<'madrs' | 'gaf'> | undefined;
}

export default InterviewSurveysForm;
